var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAlerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 67,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.309,
    cy: 56.071,
    rx: 58.809,
    ry: 10.76,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.102 1.167h6.4l-6.4 8h6.4M66.301 13.967h8l-8 9.6h8M52.43 45.968a4.452 4.452 0 008.544 0",
    stroke: "#9BA7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.56 7.567a15.839 15.839 0 00-6.86-1.6 16 16 0 00-16 16c0 12.562-3.2 17.6-3.2 17.6h38.401a21.37 21.37 0 01-2.666-7.814",
    stroke: "#9BA7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgNoAlerts;